export default __webpack_public_path__ + "static/media/street.138afc00.svg";